import { render, staticRenderFns } from "./ButtonComeBack.vue?vue&type=template&id=74c3335a"
import script from "./ButtonComeBack.vue?vue&type=script&lang=js"
export * from "./ButtonComeBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports